import { useState, useCallback, useEffect, useRef } from 'react';
import { toast } from 'react-toastify';
import { api } from 'api/config';

const MAX_FAVOURITES = 8;
const userApi = api();

export function useFavourites() {
  const [favourites, setFavourites] = useState([]);
  const saveTimer = useRef(null);

  // Load from backend on mount
  useEffect(() => {
    userApi.get('/user/me/favourites')
      .then((res) => { if (res.data?.success) setFavourites(res.data.data || []); })
      .catch(() => {});
  }, []);

  // Debounced save to backend (300ms after last change)
  const persist = useCallback((slugs) => {
    clearTimeout(saveTimer.current);
    saveTimer.current = setTimeout(() => {
      userApi.put('/user/me/favourites', { favourites: slugs }).catch(() => {});
    }, 300);
  }, []);

  const toggleFavourite = useCallback((slug) => {
    setFavourites((prev) => {
      if (!prev.includes(slug) && prev.length >= MAX_FAVOURITES) {
        toast.warning(`Favourites limit reached (max ${MAX_FAVOURITES})`, { toastId: 'fav-limit' });
        return prev;
      }
      const next = prev.includes(slug)
        ? prev.filter((s) => s !== slug)
        : [...prev, slug];
      persist(next);
      return next;
    });
  }, [persist]);

  const isFavourite = useCallback((slug) => favourites.includes(slug), [favourites]);

  return { favourites, toggleFavourite, isFavourite };
}
